import { gsap } from 'gsap/gsap-core'
import { isTouchDevice } from './utils/checkDevice'

let cursorTarget = ".custom-cursor"

function setupCursor()
{

  gsap.set(cursorTarget, {xPercent: -50, yPercent: -50});

  const cursor = document.querySelector(".custom-cursor");
  const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  const mouse = { x: pos.x, y: pos.y };
  const speed = 0.35;

  const xSet = gsap.quickSetter(cursor, "x", "px");
  const ySet = gsap.quickSetter(cursor, "y", "px");

  window.addEventListener("mousemove", e => {
    mouse.x = e.x;
    mouse.y = e.y;
  });

  gsap.ticker.add(() => {
    const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

    pos.x += (mouse.x - pos.x) * dt;
    pos.y += (mouse.y - pos.y) * dt;
    xSet(pos.x);
    ySet(pos.y);
  });

  setupCursorEvent()

}

function setupCursorEvent()
{
  $('body').on('mouseenter', '[data-cursor]', function (){


    let cursor = $('.custom-cursor')
    let cursorClass = $(this).data('cursor')

    cursor.removeClass('light').removeClass('dark').removeClass('pink').addClass(cursorClass)

  })

  $('body').on('mouseleave', '[data-cursor-leave]', function (){

    let cursor = $('.custom-cursor')
    let cursorClass = $(this).data('cursor-leave')

    cursor.removeClass('light').removeClass('dark').removeClass('pink').addClass(cursorClass)

  })
}
if(!isTouchDevice()) {
  setupCursor();
  $(cursorTarget).removeClass('d-none')
}

export { setupCursorEvent }
